import { axios as api } from './api';

const routePrefix = '/urls';

export const getFileUrl = async (
  fileId: number,
  partnerName?: string | null
): Promise<string> => {
  return api.get(
    `${routePrefix}/file/${fileId.toString()}?partnerName=${partnerName}`
  );
};

export const downloadFilesAsZip = async (
  fileIds: number[],
  partnerName: string | null,
  format: 'zip' = 'zip'
): Promise<Blob> =>
  api.post(
    `${routePrefix}/files/download`,
    { fileIds, partnerName, format },
    { responseType: 'blob' }
  );
